import React, { useContext, useEffect, useRef, useState } from 'react';
import { Badge, BlockStack, Box, Button, Card, Divider, Icon, InlineGrid, Collapsible, InlineStack, Link, Page, Select, Text, Banner, Modal, Tooltip } from '@shopify/polaris';
import { ChevronLeftMinor, ChevronRightMinor, InfoMinor, StatusActiveMajor } from '@shopify/polaris-icons';
import { Carousel, message } from 'antd';
import { basicSupportServices, contentStyle, enhancedSupportFeatures, enterprisePlanFeatures, enterpriseSupportFeatures, freePlanFeatures, growthPlanFeatures, premiumSupportFeatures } from './staticData';
import './css/NewPricingFeb2025.css';
import { useTranslation } from 'react-i18next';
import { featureModalI, planModalI, PricingProps, SettlementI } from '../Pricing/Utilities/Interfaces';
import { environment } from 'src/environments/environment';
import { useDebounce } from '../useDebounce';
import { DI, DIProps } from '../../../Core';
import { t } from 'i18next';
import PricingCard from './Components/PricingCard';
import CheckoutModal from './Components/CheckoutModal';
import { appBridgeRedirect, appBridgeRouting } from '../Panel/index';
import MarketingComparison from './Components/MarketingComparison';
import { InfoIcon } from '../../../Asests/svgIcon/icon';
import Marketing_offerCard from './Components/Marketing_offerCard';
import PricingComparison from './Components/PricingComparison';
import { formatDate } from '../Pricing/Utilities/Helper';
import { PricingGridSkelton } from './skeleton/PricingSkeleton';


const NewPricingFeb2025 = (props: PricingProps) => {
    const pricingSubtitle: any = <Text as="span">{t("Select the ideal plan for your business and access exclusive features. Benefit from flexible pricing and premium support to fuel your growth. Review our")} <Link url='https://support.cedcommerce.com/portal/en/kb/articles/pricing-updates' target='_blank'>{t("Pricing Updates")}</Link> {t("for a seamless and secure experience.")}</Text>
    const [planAPILoader, setplanAPILoader] = useState(false)
    const [planData, setplanData] = useState({})

    const [monthlyPlans, setMonthlyPlans] = useState<any>([]);
    const [openMarketingComparison, setOpenMarketingComparison] = useState(false);
    const [openPricingComparison, setOpenPricingComparison] = useState(false);
    const [pendingProcess, setPendingProcess] = useState<any>(undefined);
    const [marketing_offer, setMarketing_offer] = useState<any>({})
    const [activePlanName, setactivePlanName] = useState<any>('');
    const [activePlanID, setactivePlanID] = useState<string>('');
    const [activePlanData, setActivePlanData] = useState<any>({});
    const [syncActivated, setSyncActivated] = useState<boolean>(true);
    const [settlementModal, setSettlementModal] = useState<SettlementI>({
        open: false,
        planId: '',
        data: {}
    });
    const carouselRef = useRef<any>(null);
    const [slideData, setSlideData] = useState({
        currentSlide: 0,
        totalSlide: carouselRef.current?.innerSlider?.state?.slideCount,
        slideToShow: carouselRef.current?.innerSlider?.props?.slidesToShow
    })

    // api call to get all standard plans
    const getAll = (planType?: string) => {
        let obj: any = {};
        let monthlyPlan: any = [];
        let yearlyPlan: any = [];
        let monthlyFreePlusUser: any = [];
        let monthlyTrialPlusUser: any = [];
        setplanAPILoader(true)

        obj['category'] = planType ?? "regular"
        props.di.GET('plan/plan/get', obj).then((data: any) => {
            if (data.success) {
                let allPlan = data?.data?.data?.rows
                let TempPlan = {}
                Object.keys(allPlan)?.forEach((plan: any) => {
                    monthlyPlan.push(allPlan?.[plan]?.monthly);
                })
                if (props?.redux?.current?.source?.plan_name == 'shopify_plus') {
                    setMonthlyPlans([...monthlyPlan?.filter((plan: any) => {
                        if (plan?.title?.toLowerCase() == t('free')) {
                            monthlyFreePlusUser.push(plan)
                        } else if (plan?.title == 'Trial') {
                            monthlyTrialPlusUser.push(plan)
                        }
                        return (plan?.title !== 'Free' && plan?.title !== "Trial")
                    })])
                } else {
                    setMonthlyPlans([...monthlyPlan.filter((plan: any) => plan?.title !== "Trial")]);
                }


                // Adding Enterprise Plan (if not already added)
                if (!monthlyPlan.some((plan: any) => plan.code === "enterprise")) {
                    monthlyPlan.push({
                        code: "enterprise",
                        title: "Enterprise",
                        description: "For enterprises that need custom solutions for their Amazon business",
                        custom: true, // Custom flag to differentiate the enterprise card
                    });
                }

                // Reordering Free Plan (Move to Second Last)
                const freePlanIndex = monthlyPlan.findIndex((plan: any) => plan.code === "free");
                if (freePlanIndex !== -1) {
                    const [freePlan] = monthlyPlan.splice(freePlanIndex, 1);
                    const lastIndex = Math.max(0, monthlyPlan.length);
                    monthlyPlan.splice(lastIndex, 0, freePlan);
                }

                // Updating State
                setMonthlyPlans([...monthlyPlan]);
                let tempMonthlyObj: any = {};
                let tempYearlyObj: any = {};

                monthlyPlan?.forEach((plan: any) => tempMonthlyObj[plan?.plan_id] = false)
                yearlyPlan?.forEach((plan: any) => tempYearlyObj[plan?.plan_id] = false)


            }
            else props.error(t(data.message));
            setplanAPILoader(false);
        });
    };

    const [loadPayButton, setloadPayButton] = useState<boolean>(false);

    // api call to pay settlement amount
    const settleServices = () => {
        setloadPayButton(true);
        props.di.GET('plan/plan/settleServices', {
            amount: activePlanData?.settlement_info?.settlement_price,
            type: 'onetime',
        })
            .then((data: any) => {
                if (data.success) {
                    let tempUrl = data?.data?.confirmation_url ?? '';

                    if (data.message == 'Capped amount already set.') {
                        props.error(t(data?.message));
                        setloadPayButton(false);
                    } else if (process.env.REACT_APP_PROD === "1") {
                        appBridgeRedirect(tempUrl, props);
                    } else {
                        window.open(tempUrl);
                    }
                } else {
                    props.error(t(data?.message));
                }
                setloadPayButton(false);
            });
    }


    const [planBadgeDetails, setPlanBadgeDetails] = useState({})


    useEffect(() => {
        // Initialize the planDetails object
        let planDetails: any = {

        };

        // First, flatten all plans into a single array.
        // If a plan group has variations, we take all of them;
        // otherwise, we take the plan itself.
        if (monthlyPlans.length > 0) {

            const allPlans = monthlyPlans.reduce((acc: any[], group: any) => {
                if (group.has_variations && group.plans && group.plans.length > 0) {
                    return acc.concat(group.plans);
                } else {
                    acc.push(group);
                }
                return acc;
            }, []);






            // 1. Find the active plan (if any)
            const activePlan = allPlans.find((plan: any) => plan?.plan_id === activePlanID);



            // 2. Determine the recommended plan.
            //    a. If the active plan exists and it also has either a badge or a recommended tag,
            //       then use the active plan as the recommended plan.
            //    b. Otherwise, try to find another plan with tag === 'recommended'
            //    c. If no plan with the recommended tag exists, then look for one with a badge.
            let recommendedPlan = null;
            if (activePlan) {

                // if (activePlan.badge || (activePlan.tag && activeplan.tag.type.toLowerCase() === 'recommended')) {
                //     recommendedPlan = activePlan;
                // } else {

                // Look for a plan with tag 'recommended' (excluding active plan)
                recommendedPlan = allPlans.find(
                    (plan: any) => {
                        return plan?.tag && plan?.tag?.type === 'recommended' && plan?.plan_id !== activePlan.plan_id
                    }
                )





                // If not found, then look for a plan with a badge (excluding active plan)
                if (!recommendedPlan) {
                    recommendedPlan = allPlans.find(
                        (plan: any) => plan.badge && plan?.plan_id !== activePlan?.plan_id
                    );
                }
                // }
            } else {
                // If no active plan, still try to find a recommended one.
                console.log(allPlans.find((plan: any) => plan.tag && plan.tag.type.toLowerCase() === 'Recommended'), "xdcfgtjhfjyjtyjktyvbhjnmk")
                recommendedPlan =
                    allPlans.find((plan: any) => plan.tag && plan.tag.type.toLowerCase() === 'recommended') ||
                    allPlans.find((plan: any) => plan.badge);
            }




            // Save only plan name & plan id into planDetails.
            if (activePlan) {
                planDetails['active'] = {
                    plan_name: activePlan.title,
                    plan_id: activePlan?.plan_id,
                    price: activePlan?.custom_price
                };
            }

            if (recommendedPlan && (!activePlan || (activePlan?.custom_price < recommendedPlan?.custom_price))) {
                planDetails.recommended = {
                    plan_name: recommendedPlan.title,
                    plan_id: recommendedPlan?.plan_id,
                    price: recommendedPlan?.custom_price,
                    tag: recommendedPlan?.tag?.type || recommendedPlan?.tag?.badge || 'Recommended',
                    message: recommendedPlan?.tag?.message || undefined
                };
            }




            setPlanBadgeDetails(planDetails)
        }

    }, [monthlyPlans, activePlanID]);



    useEffect(() => {
        getAll();
        getActive()

    }, [])


    const [choosePlanLoading, setchoosePlanLoading] = useState<Boolean>(false)

    // api to Choose plan
    const choosePlan = (planId: any, planName?: string) => {
        setchoosePlanLoading(true)
        props.di.GET('plan/plan/choose', { plan_id: planId })
            .then((data: any) => {
                setchoosePlanLoading(false)
                if (data?.hasOwnProperty('can_proceed_import') && !data?.can_proceed_import) {
                    props.di.globalState.set('plan', JSON.stringify({
                        plan_name: planName,
                        plan_id: planId
                    }))
                    props.importValidation()
                }
                if (data.success) {
                    if (data?.data?.confirmation_url) {
                        let tempUrl = data?.data?.confirmation_url;
                        props.di.globalState.removeLocalStorage(`is_plan_active`)
                        if (process.env.REACT_APP_PROD === "1") {
                            appBridgeRedirect(tempUrl, props);
                        }
                        else window.open(tempUrl)
                    }
                    else {
                        props.di.globalState.removeLocalStorage(`is_plan_active`)
                        props.history("./home")
                        // props.planIsActive();
                    }

                    if (planName == 'Trial') {
                        props.di.globalState.set(`trial_plan_active`, data?.message);
                        appBridgeRouting("dashboard", props)
                    }

                    if (planName == 'Free') {
                        props.success(t(data?.message))
                        // setFlagForceRender(!flagForceRender)
                    }

                    setPlanModal({ active: false, plan_data: {} })
                }
                else props.error(t(data?.message));

                // monthlyTemp[planId] = false;
                // yearlyTemp[planId] = false;
                // setMonthlyButtonLoading({ ...monthlyTemp });
                // setYearlyButtonLoading({ ...yearlyTemp });
            });
    }



    // api call for active plan
    const getActive = () => {
        props.di.GET('plan/plan/getActive').then((data: any) => {
            setPendingProcess(data?.data?.pending_processes && data?.data?.pending_processes?.length > 0 ? data?.data?.pending_processes : undefined)
            if (data.success) {
                setactivePlanName(data?.data?.active_plan?.plan_details?.title);
                setActivePlanData(data?.data)
                setactivePlanID(data?.data?.active_plan?.plan_details?.plan_id)


                if (data?.data?.settlement_info && Object?.values(data?.data?.settlement_info)?.length > 0 && !data?.data?.settlement_info) {
                    props.di.globalState.set('isPlanExpired', JSON.stringify({}))
                    props.di.globalState.set('isSettlementGenerated', JSON.stringify(data?.data?.settlement_info))
                    props.checkPlanExpiration();
                }
                else {
                    props.di.globalState.removeLocalStorage('isSettlementGenerated')
                    props.di.globalState.set('isPlanExpired', JSON.stringify({}))
                    props.checkPlanExpiration()
                }
                if (data?.data?.sync_activated === false) {
                    setSyncActivated(false)
                    // if (+data?.data?.user_service?.prepaid?.service_credits == 50) {
                    //     props.error(data?.message, { content: '', onAction: () => { } }, 12000);
                    //     props.di.globalState.set('is_plan_active', 'open_plan')
                    //     props.updatePlanStatus('_PENDING_');
                    // }
                    // else
                    if (data?.data?.settlement_info && data?.data?.settlement_info?.invoice && Object.keys(data?.data?.settlement_info?.invoice)?.length > 0) {
                        props.error(t(data?.message), { content: '', onAction: () => { } }, 12000);
                        props.updatePlanStatus('_PENDING_');
                    }
                    else {
                        props.di.globalState.set('is_plan_active', 'true');
                        props.updatePlanStatus('_DONE_');
                    } props.di.globalState.set('is_plan_active', 'open_plan')

                } else {
                    setSyncActivated(true)
                    props.di.globalState.set('is_plan_active', 'true')
                    props.updatePlanStatus('_DONE_')
                }
            }
            else {
                props.error(t(data.message ?? "something went wrong"))
                // setactivePlanName('')
                // setactivePlanID('')
            }
            // setactiveSkeleton(false);
        });
    }


    const [planModal, setPlanModal] = useState<any>({
        active: false,
        plan_data: null
    })

    const setPlanModalToggle = (data: boolean, plan_data: any = null) => {

        setPlanModal({
            active: data,
            plan_data: plan_data
        })
    }

    const handleCurrentSlide = () => {
        const currentSLide = carouselRef.current?.innerSlider?.state?.currentSlide;
        const totalSlide = carouselRef.current?.innerSlider?.state?.slideCount;
        const slideToShow = carouselRef.current?.innerSlider?.props?.slidesToShow;
        setSlideData({
            currentSlide: currentSLide,
            totalSlide: totalSlide,
            slideToShow: slideToShow
        })
    }
    return (
        <div className='custom-pricing-feb2025'>
            <Page
                backAction={{ content: 'Subscription Plan', onAction: () => props.history('../home') }}
                title="Pricing Plans"

                subtitle={pricingSubtitle}
            >
                <BlockStack gap={"800"}>
                    {pendingProcess && <Banner title={t('Payment is in progress')} tone='info'>
                        <Text as='p'>

                            {t("Your payment is currently being processed. You will be notified once it is successful.")}

                        </Text>
                    </Banner>}
                    <div className="custom-new-pricing__container">
                        <Card background='bg-surface'>
                            <BlockStack gap={"600"}>
                                {monthlyPlans?.length === 0 ? <PricingGridSkelton /> :
                                    <div className="custom-pricingCarousel Custom--Pricing-Slider-Dot Custom--Pricing-arrow">
                                        <Carousel
                                            ref={carouselRef}
                                            {...contentStyle.carouselProps}
                                            afterChange={handleCurrentSlide}
                                            prevArrow={<Button icon={ChevronLeftMinor} size='large' id='custom-newPricing-prev-btn' disabled={slideData?.currentSlide === 0} />}
                                            nextArrow={<Button icon={ChevronRightMinor} size='large' id='custom-newPricing-next-btn' disabled={
                                                (slideData?.currentSlide + slideData?.slideToShow) === slideData?.totalSlide
                                            } />}
                                        >
                                            {monthlyPlans.map((plan: any) =>
                                                plan?.custom ? (
                                                    // Enterprise Plan Card
                                                    <div key={plan?.code} className="Custom-NewPricing--Card">
                                                        <Box background="bg-surface-selected" padding={"500"} borderRadius="300">
                                                            <BlockStack gap={"500"}>
                                                                <BlockStack gap={"300"}>
                                                                    <BlockStack gap={"800"}>
                                                                        <BlockStack gap={"050"}>
                                                                            <Text as="p" variant="headingMd"><span className="fs-16">{t(plan.title)}</span></Text>
                                                                            <Text as="p" variant="bodyMd" tone="subdued">{t(plan.description)}</Text>
                                                                        </BlockStack>
                                                                        <Text as="p" variant="heading2xl">{t("Custom")}</Text>
                                                                    </BlockStack>
                                                                    <div style={{ height: "38px", minHeight: "38px" }}></div>
                                                                    <Divider borderColor="border" />
                                                                    <BlockStack inlineAlign="start" gap={"200"}>
                                                                        {enterprisePlanFeatures.map((feature: any, ind: any) => (
                                                                            <InlineStack gap={"200"} key={ind} wrap={false}>
                                                                                <Icon source={StatusActiveMajor} tone="success" />
                                                                                <Text as="p" variant="bodyMd" fontWeight={"regular"}>{t(feature)}</Text>

                                                                            </InlineStack>
                                                                        ))}
                                                                    </BlockStack>
                                                                </BlockStack>
                                                                <Button onClick={() => window.open("https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g7NeU-DtavtyOoK6p_Vz_yix_xRdVCebaqHDOmQSxNt1J2_vO5ZaeqC_oDURH15RoA2-LGV2M", "__blank")} size="large">{t("Contact Us")}</Button>
                                                            </BlockStack>
                                                        </Box>
                                                    </div>
                                                ) : (
                                                    // Regular Pricing Plans
                                                    <PricingCard
                                                        key={plan?.plan_id}
                                                        activePlanName={activePlanName}
                                                        activePlanData={activePlanData}
                                                        activePlanID={activePlanID}
                                                        planBadgeDetails={planBadgeDetails}
                                                        buyNowAction={setPlanModalToggle}
                                                        plan={plan}
                                                        setSettlementModal={setSettlementModal}
                                                        planType={"monthly"}
                                                    />
                                                )
                                            )
                                            }
                                        </Carousel>
                                    </div>}
                                <Button variant='plain' disclosure={openPricingComparison ? "up" : "down"} onClick={() => setOpenPricingComparison(!openPricingComparison)}>{t("View Full Comparison")}</Button>
                                <Collapsible
                                    open={openPricingComparison}
                                    id="support-plan-basic-collapsible"
                                    transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                    expandOnPrint
                                >
                                    <PricingComparison carouselRef={carouselRef} />
                                </Collapsible>
                            </BlockStack>
                        </Card>
                    </div>
                    <Card background='bg-surface'>
                        <BlockStack gap={"800"}>
                            <BlockStack gap={"050"}>
                                <Text as='p' variant='headingLg'>{t("Support Plans")}</Text>
                                <Text as='p' variant='bodyMd' tone='subdued'>{t("Our support and marketing services will guide you through every step of the process, from setup to success.")}</Text>
                            </BlockStack>
                            <BlockStack gap={"600"}>
                                <div className='Custom-radius-12'>
                                    <Box background='bg-surface-selected' padding={"500"} borderRadius='300'>
                                        <InlineStack gap={"800"} align='space-between' wrap={false}>
                                            <div className='flex-1'>
                                                <BlockStack gap={"400"}>
                                                    <BlockStack gap={"050"}>
                                                        <Text as='p' variant='headingMd'><span className='fs-16'>{t("Basic Support")}</span></Text>
                                                        <Text as='p' variant='bodyMd' tone='subdued'>{t("For new sellers and small businesses")}</Text>
                                                    </BlockStack>
                                                    <InlineStack gap={"300"} blockAlign='center' align='start'>
                                                        <div className='Custom-radius-6'>
                                                            <Box background='bg-surface-success-hover' paddingInline={"200"} paddingBlock={"150"}>
                                                                <Text as='p' variant='bodyMd'>{t("No Additional Cost")}</Text>
                                                            </Box>
                                                        </div>
                                                    </InlineStack>
                                                </BlockStack>
                                            </div>
                                            <span className='custom-newPricing-divider'></span>
                                            <div className='flex-1 align-self-center'>
                                                <BlockStack inlineAlign='start' gap={"200"}>
                                                    {basicSupportServices.map((feature: any, ind: any) => (
                                                        <InlineStack gap={"200"} key={ind} wrap={false}>
                                                            <Icon source={StatusActiveMajor} tone='success' />
                                                            <Text as='p' variant='bodyMd' fontWeight={"regular"}>{t(feature.trim())}</Text>
                                                        </InlineStack>
                                                    ))}
                                                </BlockStack>
                                            </div>
                                        </InlineStack>
                                    </Box>
                                </div>
                                <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }} gap={"400"}>
                                    <Marketing_offerCard />
                                </InlineGrid>
                                <Button variant='plain' disclosure={openMarketingComparison ? "up" : "down"} onClick={() => setOpenMarketingComparison(!openMarketingComparison)}>{t("View Full Comparison")}</Button>
                                <Collapsible
                                    open={openMarketingComparison}
                                    id="pricing-main-basic-collapsible"
                                    transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                    expandOnPrint
                                >
                                    <MarketingComparison />
                                </Collapsible>
                            </BlockStack>
                        </BlockStack>
                    </Card>
                    <Card background='bg-surface-warning'>
                        <BlockStack gap={'100'}>
                            <Text fontWeight='semibold' as='p' variant='bodyLg'>{t("Convert Clicks into Customers")}</Text>
                            <InlineStack align='space-between' blockAlign='center' wrap={false} gap={"300"}>
                                <div className='flex-1'>
                                    <Text variant='bodyMd' as='p'>{t("Enhance your presence on Amazon with our professional marketing services and secure rankings through targeted ads, keyword optimization, and more to achieve quantifiable sales growth.")}</Text>
                                </div>
                                <Button size='slim' variant="primary" onClick={() => window.open("https://cedcommerce.com/marketing-services/amazon-marketing", "__blank")} >{t("Explore Now")}</Button>
                            </InlineStack>
                        </BlockStack>
                    </Card>
                </BlockStack>
                <CheckoutModal choosePlan={choosePlan} choosePlanLoading={choosePlanLoading} open={planModal} setOpen={setPlanModalToggle} />




                {/* Settlement Modal */}
                <Modal
                    open={settlementModal.open}
                    title={t('Attention!')}
                    onClose={() => setSettlementModal({ open: false, planId: '', data: {} })}
                    primaryAction={{
                        content: t('Pay Now'),
                        onAction: () => settleServices(),
                        // disabled: !settlementModal.data?.invoice?.show_pay_now,
                        loading: loadPayButton
                    }}
                >
                    <Modal.Section>
                        <BlockStack gap="400">
                            <Text as='p' fontWeight='semibold'>
                                {t("Kindly pay the Excess Usage Charges to proceed choosing a new plan.")}
                            </Text>
                            <Divider />
                            <InlineStack gap='400' align='space-between' wrap={false}>
                                <Text as='p' fontWeight='semibold'>{t("Excess usage charge generated")}</Text>
                                <Text as='p' fontWeight='semibold'>{
                                    Object.values(settlementModal.data)?.length > 0 ?
                                        `$${settlementModal.data?.settlement_price}.00 USD` : "$00.00 USD"
                                }</Text>
                            </InlineStack>
                            <InlineStack align='space-between' gap="400" wrap={false}>
                                <Text as='p' tone='subdued'>({formatDate(settlementModal?.data?.invoice?.generated_at)} - {formatDate(settlementModal?.data?.invoice?.updated_at)})</Text>
                                <Text as='p' tone='subdued'>(${settlementModal?.data?.invoice?.postpaid?.per_unit_usage_price || 0.00}/ {settlementModal?.data?.invoice?.postpaid?.unit_qty > 1 ? settlementModal?.data?.invoice?.postpaid?.unit_qty + ' orders' : settlementModal?.data?.invoice?.postpaid?.unit_qty + ' order'})</Text>
                            </InlineStack>
                            <Divider />
                            <>
                                <BlockStack gap="200">
                                    <InlineStack gap="100">
                                        <Text as='p' tone='success' fontWeight='semibold'>{t("LAST DAY TO SETTLE:")} </Text>
                                        <Text as='p' tone='success' fontWeight='semibold'>{formatDate(settlementModal.data?.invoice?.last_payment_date)} (12am GMT, 5am IST)</Text>
                                    </InlineStack>
                                    <BlockStack gap="100">
                                        <Text as='p'>{
                                            (activePlanData?.hasOwnProperty('sync_activated') && activePlanData?.sync_activated === true) ?
                                                "If you pay excess usage charges with a remaining credit balance, accessing additional credits within the same month will be restricted. Credits will be renewed at the start of the next month."
                                                :
                                                "Once you pay your excess usage charges, you will immediately gain access to the app. Your plan credits will renew automatically at the beginning of the next month."
                                            // "Kindly pay the Excess Usage Charges to ensure continuous order syncing."
                                        }</Text>
                                        <InlineStack gap="100">
                                            <Link removeUnderline onClick={() => activePlanName == '' || !syncActivated ? props.history('../panel/support', { replace: false, state: { fromPricingPlan: true } }) : props.history('../support')}>{t("Contact us")}</Link>
                                            <Text as='p'>{t("or read the")}</Text>
                                            <Link removeUnderline onClick={() => {
                                                if (activePlanName == '' || !syncActivated) {
                                                    props.di.globalState.set('fromPricingPlan', 'true')
                                                    props.history('../panel/faq')
                                                } else {
                                                    props.di.globalState.set('fromPricingPlan', 'true')
                                                    props.history('../faq')
                                                }
                                            }}>{t("frequently asked questions")}</Link>
                                            <Text as='p'>{t("for further assistance.")}</Text>
                                        </InlineStack>
                                    </BlockStack>
                                </BlockStack>
                            </>
                        </BlockStack>
                    </Modal.Section>
                </Modal>


            </Page>
        </div >
    )
}

export default DI(NewPricingFeb2025);